import { GenericField, GenericInput } from '@/ui'
import { XIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export const NICKNAME_MAX_LENGTH = 60

export interface NicknameFieldProps {
	value: string
	onChange: (value: string) => void
	disabled?: boolean
}

export function NicknameField({ value, onChange, disabled = false }: NicknameFieldProps) {
	const { t } = useTranslation('common')

	return (
		<GenericField
			label={t('settings.paymentMethods.editNickname.label')}
			topRightTooltip={
				<span className="text-sm text-grey-500">
					{t('settings.customFields.optional')}
				</span>
			}
		>
			<GenericInput isDisabled={disabled}>
				{({ className }) => (
					<>
						<input
							type="text"
							value={value}
							onChange={(e) => onChange(e.target.value)}
							maxLength={NICKNAME_MAX_LENGTH}
							disabled={disabled}
							className={`${className} pr-9`}
						/>
						{value.length > 0 && (
							<button
								type="button"
								onClick={() => onChange('')}
								disabled={disabled}
								aria-label={t('settings.paymentMethods.editNickname.clear')}
								className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center size-6 rounded-full text-grey-400 hover:text-grey-700 hover:bg-grey-100 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed appearance-none border-none bg-transparent"
							>
								<XIcon className="size-3.5" />
							</button>
						)}
					</>
				)}
			</GenericInput>
		</GenericField>
	)
}
